// extracted by mini-css-extract-plugin
export default {"mySwitch":"MySwitch_mySwitch__iIyeT"};